<template lang="pug">
  nav
    .logo.seccion.fondo-morado
      router-link(to="/")
        img(alt="Logo Ellas Libres de Violencias", src="@/assets/LogoEllas.svg")
    .fondo-lila.seccion
      router-link(to="/") Inicio 
      router-link(to="/preguntas-frecuentes/0") Preguntas frecuentes
      router-link(to="/citas") Para recordar
      router-link(to="/saber-mas") Para saber más
    .fondo-blanco.seccion
      router-link(to="/nosotras") ¿Qué es Ellas?
      a(href="https://docs.google.com/forms/d/1LBfksSga5UTLltcQkwEKfv_BG4LS3joOsnWR6KoCOCo/viewform?edit_requested=true", target="_blank") Cuéntanos tu experiencia
      a(@click="$emit('interruptor', 1)").pointer En caso de emergencia
      a(@click="$emit('interruptor', 2)").pointer Líneas de orientación
      router-link(to="/contacto-de-emergencia") Contacto de emergencia
      a(href="https://ellascentrodeaprendizaje.com/") Ellas: Centro de Aprendizaje
      router-link(to="/comunidad") Comunidad Ellas
      
    .fondo-morado.seccion
      ul.distribucion-vertical
        - var w = "30px"
        li(@click="aViolencias('fisica')").pointer 
          img(src="@/assets/iconos-violencias/icono-fisica.svg", width=w)
          span Violencia física o psicológica
        li(@click="aViolencias('sexual')").pointer 
          img(src="@/assets/iconos-violencias/icono-sexual.svg", width=w)
          span Violencia sexual
        li(@click="aViolencias('economica')").pointer 
          img(src="@/assets/iconos-violencias/icono-economica.svg", width=w)
          span Violencia económica
        li(@click="aViolencias('politica')").pointer 
          img(src="@/assets/iconos-violencias/icono-politica.svg", width=w)
          span Violencia política
        li(@click="aViolencias('acoso')").pointer 
          img(src="@/assets/iconos-violencias/icono-acoso.png", width=w)
          span Acoso sexual
    .fondo-blanco.seccion
      router-link(to="/legal/6") Política de privacidad para la app ellas libres de violencias
</template>
<script>

export default {
  name: 'Menu',
  methods: {
    
    aViolencias(n) {
      if(this.$store.state.municipio.length) {
        this.$router.push({ path: '/violencias/' + n  })
      } else {
        alert("Debes seleccionar tu ubicación para obtener información sobre las rutas de orientación en tu ciudad o municipio")
      }
      
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/sass/componentes/_menu"
</style>